<template>
  <div class="trial animate__animated animate__fadeIn">
    <div class="title">申请体验</div>
    <div class="desc">填写以下信息，我们将尽快与您联系</div>

    <el-card class="box-card" shadow="never" body-style="padding: 0;">
      <div class="content">
        <el-form :model="form" :rules="rules" label-position="top" ref="ruleForm" class="part left">
          <el-form-item prop="name" label="姓名" class="form-item">
            <el-input type="text" v-model.trim="form.name" autocomplete="off" placeholder="请输入您的姓名"></el-input>
          </el-form-item>
          <el-form-item prop="corpName" label="公司" class="form-item">
            <el-input type="text" v-model.trim="form.corpName" autocomplete="off" placeholder="请输入您所在公司名称"></el-input>
          </el-form-item>
          <el-form-item prop="phone" label="手机号" class="form-item">
            <el-input type="text" v-model.trim="form.phone" autocomplete="off" placeholder="请输入您的手机号码"
              maxlength="11"></el-input>
          </el-form-item>
          <el-form-item prop="interestedService" label="您感兴趣的服务（可多选）" class="form-item" style="width: 100%;">
            <el-checkbox-group v-model="form.interestedService">
              <el-checkbox v-for="item in interestedServiceList" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div class="btn-container">
          <el-button class="submit-btn" :loading="loading" @click="submitForm('ruleForm')">提交申请</el-button>
        </div>
        <div class="tip">提交即表示同意《隐私政策》，我们将保护您的个人信息安全</div>
      </div>
    </el-card>

    <el-dialog :visible.sync="visible" width="590px" center append-to-body :close-on-click-modal="false" class="submit-success">
      <div class="dialog-content">
        <template v-if="submitSuccess">
          <div class="commit">
            <i class="el-icon-success success-icon"></i>
            <span class="success-text">提交成功</span>
          </div>
        </template>
        <div class="contact">中知顾问将在 <span>3</span> 个工作日内联系您！</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" style="width: 96px;" @click="toPage">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api'

export default {
  name: 'TrialV2',
  props: {
    sceneCode: {
      type: String,
      default: ''
      // 1 "科技金融咨询"
      // 2 "深眸"
      // 3 "瞰见"
      // 4 "专利导航咨询”
      // 5 "数据服务咨询"
      // 6 "注册"
    }
  },
  data () {
    const CheckPhone = async (rule, value, callback) => {
      if (value) {
        if (/^1[3-9]\d{9}$/.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号码'))
        }
      }
    }
    return {
      form: {
        name: '',
        phone: '',
        corpName: '',
        interestedService: []
      },
      loading: false,
      visible: false,
      submitSuccess: false,
      rules: {
        name: [{ required: true, message: '请输入您的姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入您的手机号码', trigger: 'blur' },
          { validator: CheckPhone, trigger: 'blur' }
        ],
        corpName: [
          { required: true, message: '请输入您所在公司名称', trigger: 'blur' }
        ],
        interestedService: [
          { required: true, message: '请选择您感兴趣的服务', trigger: 'change' }
        ]
      },
      dict: {
        1: '解决方案咨询',
        2: '申请深眸体验',
        3: '申请瞰见体验',
        4: '咨询专利导航服务',
        5: '数据服务咨询',
        6: '申请试用'
      },
      interestedServiceList: [
        { label: '产业智能体', value: '产业智能体' },
        { label: '企业智能体', value: '企业智能体' },
        { label: '区域科创生态分析', value: '区域科创生态分析' },
        { label: '科创数据对接', value: '科创数据对接' }
      ]
    }
  },
  methods: {
    async submitForm (formName) {
      this.$refs[formName].validate().then((valid) => {
        if (valid) {
          // 这里写校验通过的业务逻辑
          this.form.content = this.dict[this.$props.sceneCode] // 必填
          api.applyForm({
            ...this.form,
            interestedService: this.form.interestedService.join(','),
            sceneCode: this.$props.sceneCode
          }).then(({ success }) => {
            if (success) {
              this.submitSuccess = true
              this.visible = true
              this.$refs[formName].resetFields() // 重置表单数据
            }
          })
        }
      })
    },
    toPage () {
      this.visible = false
      this.$router.push('/home')
      window.scrollTo(0, 0, 'smooth')
    }
  }
}
</script>

<style lang='scss' scoped>
.trial {
  position: relative;

  .title {
    @include Text(32px, 500, 45px, #111, 'PingFangSC-Medium');
  }

  .desc {
    margin-top: Translate(2px);
    @include Text(14px, 400, 20px, #999, 'PingFangSC-Regular');
  }

  .box-card {
    width: Translate(900px);
    margin: Translate(27px) auto 0;
    border-radius: Translate(10px);
    border: none;
  }

  .content {
    padding: Translate(44px) 0;
    width: Translate(780px);
    margin: 0 auto;

    .btn-container {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: Translate(18px);
      margin-bottom: Translate(18px);

      .submit-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: Translate(280px);
        height: Translate(48px);
        background-image: linear-gradient(90deg, #0058FF 0%, #12A4FA 100%);
        border-radius: Translate(24px);
        border: none;
        outline: none;
        @include Text(16px, 400, 48px, #FFFFFF, 'PingFangSC-Regular');

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .part {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      text-align: left;

      .code {
        position: relative;

        .captcha {
          width: Translate(80px);
          position: absolute;
          right: 10px;
          top: 0;
          bottom: 0;
          margin: auto;
        }

        .error {
          position: absolute;
          bottom: -35px;
          @include Text(12px, 400, 20px, #f56c6c, 'PingFangSC-Regular');
        }
      }
    }

    form {
      .el-input {
        width: 380px;
      }

      ::v-deep .form-item .el-input__inner {
        height: 48px;
        border: 1px solid #e3e6e9;
      }

      ::v-deep label {
        @include Text(14px, 500, 20px, #333, 'PingFangSC-Medium');
      }

      ::v-deep .el-checkbox-group {
        line-height: 20px;
      }

      ::v-deep .el-form-item {
        margin-bottom: 28px;
      }

      ::v-deep .el-checkbox__label {
        font-family: 'PingFangSC-Regular';
        font-weight: 400;
      }
    }

    .right {
      .title {
        display: flex;
        align-items: center;
        color: #0058FF;
        font-size: 46px;
        padding-bottom: 30px;

        img {
          width: 60px;
          padding-right: 40px;
        }
      }

      .main {
        padding-bottom: 80px;
        display: flex;

        img {
          width: 280px;
          margin-right: 40px;
          padding: 20px;
          border: 1px solid #e5e6e9;
        }
      }
    }
  }
}

.tip {
  @include Text(12px, 400, 17px, #999, 'PingFangSC-Regular');
}
</style>

<style lang="scss">
.submit-success {
  .el-dialog {
    .el-dialog__header {
      padding-top: 46px;
      background: #FAFAFA;
    }
  }

  .el-dialog__body {
    padding-top: 50px;
    padding-bottom: 0;
  }

  .dialog-content {
    font-size: Translate(20px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .contact {
      padding: Translate(24px) 0 Translate(66px) 0;
      text-align: center;
      @include Text(16px, 400, 24px, #333333, 'PingFangSC-Regular');

      span {
        color: orange;
      }
    }

    .commit {
      color: #00A854;

      .success-icon {
        margin-right: 10px;
        font-size: Translate(24px);
        vertical-align: Translate(-4px);
      }

      .success-text {
        font-size: Translate(20px);
        vertical-align: middle;
      }
    }
  }
}
</style>
